// SKR-1471: a "flight" segment whose endpoint is a rail (R) or bus (B) station is really a train/bus leg.
// Airport types come from airports.type_code via departureAirportType/arrivalAirportType on each segment.
export const TRANSPORT_TRAIN = 'train';
export const TRANSPORT_BUS = 'bus';

const TYPE_RAIL = 'R';
const TYPE_BUS = 'B';

export default class TransportHelper {
    static getSegmentTransport(segment) {
        if (!segment) {
            return null;
        }

        const types = [segment.departureAirportType, segment.arrivalAirportType];
        if (types.includes(TYPE_RAIL)) {
            return TRANSPORT_TRAIN;
        }
        if (types.includes(TYPE_BUS)) {
            return TRANSPORT_BUS;
        }

        return null;
    }

    static getSegmentsTransports(segments) {
        const transports = (segments || []).map(TransportHelper.getSegmentTransport);

        return [TRANSPORT_TRAIN, TRANSPORT_BUS].filter((transport) => transports.includes(transport));
    }
}



// WEBPACK FOOTER //
// ./src/helpers/TransportHelper.js